// extracted by mini-css-extract-plugin
module.exports = {"BgWithText":"BgWithText_BgWithText__1GGSS","Title":"BgWithText_Title__2PySy","OverlayText":"BgWithText_OverlayText__8-FA7"};